import { makeStyles,useTheme } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>({
  wrapper: {
    display: 'flex',
    height: '100%',
    [theme.breakpoints.down('sm')]:{
      flexDirection: 'column',
      width: '100%'
    }
  },
  emailSettingsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    width: 'calc(100% - 300px)',
    paddingTop: '30px',
    marginBottom : '80px',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      marginBottom : '0px',
    }
  },
  emailSettings: {
    width: '600px',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      
    }
  },
  title: {
    margin: '0 0 19px',
    [theme.breakpoints.down('sm')]:{
      textAlign: 'center'
    }
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  input: {
    width: '100%',
    marginBottom: '20px',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
       padding: '5px 20px 2px 20px'
    }
  },
  actionButtons: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
       padding: '0px 20px 0px 20px'
    }
  },
  resetButton: {
    border: '1px solid #0e8bb4',
    borderRadius: '3px',
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 500,
    color: '#0e8bb4',
    padding: '8px 15px',
    minWidth: '80px',
    marginRight: '15px'
  },

  info: {
    width: '240px',
    padding: '30px 30px 0',
    borderLeft: '1px solid #E5E5E5',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      paddingBottom: '50px'
   
    }
  },
  infoList: {
    background: '#E2F5F8',
    border: '1px solid #B5E6EE',
    borderRadius: '3px',
    overflow: 'hidden',
    padding: '12px 10px',
    width: '220px',
    [theme.breakpoints.down('sm')]:{
      width: '100%',
      
    }
  },
  infoItem: {
    color: '#005A81',
    margin: '0 0 15px',
    '&:last-child': {
      margin: 0
    }
  }
}));
